







































































import { Vue, Component, Prop } from "vue-property-decorator";
import slugify from "slugify";

@Component
export default class Card extends Vue {
  @Prop({ type: String, required: true }) readonly id!: string;
  @Prop({ type: String, required: true }) readonly userId!: string;
  @Prop({ type: String, required: true }) readonly description!: string;
  @Prop({ type: String, required: true }) readonly question!: string;
  @Prop({ type: String, required: true }) readonly owner!: string;
  @Prop({ type: Boolean, required: true }) readonly isActive!: boolean;
  @Prop({ type: Array, required: true }) readonly users!: Array<string>;

  get questionSlug() {
    return slugify(this.question);
  }
}
